export default __webpack_public_path__ + "maps-guides-styles-layers-symbol-layer-icon-960-e545285564f01bdf494c6027db45b59c.webp";